// src/services/DniService.js

const API = '/api/dni';

/**
 * Consulta un número de DNI en nuestra API interna.
 * @param {string} dni - El número de DNI de 8 dígitos.
 * @returns {Promise<{success: boolean, nombres: string, apellido_paterno: string, apellido_materno: string}>}
 */
export const buscarDni = async (dni) => {
  try {
    // Construimos la URL con el query parameter (?dni=XXXXXXXX)
    const response = await fetch(`${API}?dni=${dni}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const data = await response.json();

    if (!response.ok) {
      // Captura tanto el error 400 (DNI inválido), 429 (Límite de tiempo) como el 500
      throw new Error(data.message || data.error || "Error al consultar el DNI");
    }

    return data;
  } catch (error) {
    // Lanza el mensaje limpio para que tu formulario lo muestre en un alert o un estado
    throw new Error(error.message);
  }
};